module.exports = __webpack_public_path__ + "img/car.98157181.svg";